/*
 * Nao ha `EnumPasswordStrength` aqui, de proposito: ele veio orfao na copia do
 * accounts e nao ha tela de senha num app de SSO -- quem cuida de credencial e
 * o liberty/auth.
 */

/**
 * As rotas que esta aplicacao atende sem sessao.
 *
 * `/sso` e a entrada vinda do admin. `/entrar` so existe em desenvolvimento
 * local, quando nao ha admin para emitir ticket -- em ambiente publicado ela
 * responde com um aviso e manda a pessoa para o admin (ver EntrarPage.vue).
 */
export const RotasPublicas = Object.freeze(["/sso", "/entrar"]);

export const languages = [
    {
        code: "en-US",
        label: "English",
        flag: "/images/static/flags/usa.svg",
        alt: "USA",
    },
    {
        code: "es-ES",
        label: "Español",
        flag: "/images/static/flags/spain.svg",
        alt: "España",
    },
    {
        code: "pt-BR",
        label: "Português",
        flag: "/images/static/flags/brasil.svg",
        alt: "Brasil",
    },
];

export const FormLayout = {
    Check: 2,
    Reply: 3,
};

export const ColumnTable = {
    actions: {
        width: "30px",
        smallScreenWidth: "20px",
    },
    name: {
        width: "130px",
        maxChars: 49,
        smallScreenWidth: "100px",
        smallScreenMaxChars: 25,
    },
    default: {
        width: "30px",
        maxChars: 50,
        smallScreenWidth: "60px",
        smallScreenMaxChars: 14,
    },
};

/**
 * Alimenta a busca de telas do cabecalho. `url` e a permissao no catalogo --
 * e por ela que o item so aparece para quem pode abrir a tela.
 */
export const MenuConfig = [
    {
        route: "/projetos",
        i18nKey: "components.lpbuilder.projetos.pageTitle",
        url: "lpbuilder.projetos:visualizar",
    },
    {
        route: "/modelos-secao",
        i18nKey: "components.lpbuilder.modelosSecao.pageTitle",
        url: "lpbuilder.modelos_secoes:visualizar",
    },
    {
        route: "/componentes-editaveis",
        i18nKey: "components.lpbuilder.componentes.pageTitle",
        url: "lpbuilder.versoes:editar",
    },
    {
        route: "/versoes",
        i18nKey: "components.lpbuilder.versoes.pageTitle",
        url: "lpbuilder.versoes:visualizar",
    },
    {
        route: "/publicacoes",
        i18nKey: "components.lpbuilder.publicacoes.pageTitle",
        url: "lpbuilder.deploys:visualizar",
    },
];

export const icons = [
    "mdi-account",
    "mdi-account-cog",
    "mdi-account-group",
    "mdi-account-lock",
    "mdi-domain",
    "mdi-security",
    "mdi-shield-lock",
    "mdi-cog",
    "mdi-cog-outline",
];
